<ui-card>
    <app-segment-header title="Report Line Items"> </app-segment-header>
    <p>{{ 'reporting.payroll.journalEntry.inputGlCodes' | translate }}</p>
    <p>{{ 'reporting.payroll.journalEntry.savingAutomatically' | translate }}</p>
    <form class="ui form" #form="ngForm">
        <div class="app-grid" *ngIf="journalEntryReportItemTemplates.length">
            <div class="padding-y-2" *ngIf="incomeTypeJournalEntryReportLineItems.length">
                <div class="sub-header padding-bottom-1">
                    {{ 'reporting.payroll.journalEntry.incomeType' | translate }}
                </div>
                <div *ngFor="let incomeTypeReportLineItem of incomeTypeJournalEntryReportLineItems; last as isLast">
                    <div
                        [class.padding-y-2]="incomeTypeJournalEntryReportLineItems.length > 1 && !isLast"
                        [class.padding-top-2]="incomeTypeJournalEntryReportLineItems.length > 1 && isLast"
                        class="app-grid"
                    >
                        <div class="columns-3 non-input-report-line-item">
                            {{ incomeTypeReportLineItem.displayName }}
                        </div>
                        <mat-form-field class="columns-4 no-labels no-helpers">
                            <input
                                (focusout)="onReportItemTemplateChange(incomeTypeReportLineItem)"
                                matInput
                                type="string"
                                placeholder="{{ 'reporting.payroll.journalEntry.glCodePlaceholder' | translate }}"
                                [name]="'glCodeIncomeType-' + incomeTypeReportLineItem.id"
                                [(ngModel)]="incomeTypeReportLineItem.glCode"
                            />
                        </mat-form-field>
                        <div class="columns-1"></div>
                        <div class="columns-3 non-input-report-line-item">
                            <mat-checkbox
                                [name]="'separateByDepartmentIncomeType' + incomeTypeReportLineItem.id"
                                [(ngModel)]="incomeTypeReportLineItem.separateByDepartment"
                                (change)="onReportItemTemplateChange(incomeTypeReportLineItem)"
                            >
                                <span>{{ 'reporting.payroll.journalEntry.separateByDepartment' | translate }}</span>
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>
            <div class="padding-y-2" *ngIf="deductionsJournalEntryReportLineItems.length">
                <div class="sub-header padding-bottom-1">
                    {{ 'reporting.payroll.journalEntry.deductions' | translate }}
                </div>
                <div *ngFor="let deductionReportLineItem of deductionsJournalEntryReportLineItems; last as isLast">
                    <div
                        [class.padding-y-2]="deductionsJournalEntryReportLineItems.length > 1 && !isLast"
                        [class.padding-top-2]="deductionsJournalEntryReportLineItems.length > 1 && isLast"
                        class="app-grid"
                    >
                        <div class="columns-3 non-input-report-line-item">
                            {{ deductionReportLineItem.displayName }}
                        </div>
                        <mat-form-field class="columns-4 no-labels no-helpers">
                            <input
                                (focusout)="onReportItemTemplateChange(deductionReportLineItem)"
                                matInput
                                type="string"
                                placeholder="GL Code"
                                [name]="'glCodeDeduction-' + deductionReportLineItem.id"
                                [(ngModel)]="deductionReportLineItem.glCode"
                            />
                        </mat-form-field>
                        <div class="columns-1"></div>
                        <div class="columns-3 non-input-report-line-item">
                            <mat-checkbox
                                [name]="'separateByDepartmentDeduction' + deductionReportLineItem.id"
                                [(ngModel)]="deductionReportLineItem.separateByDepartment"
                                (change)="onReportItemTemplateChange(deductionReportLineItem)"
                                [disabled]="isDisabled(deductionReportLineItem)"
                            >
                                <span>{{ 'reporting.payroll.journalEntry.separateByDepartment' | translate }}</span>
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>
            <div class="padding-y-2" *ngIf="benefitsJournalEntryReportLineItems.length">
                <div class="sub-header padding-bottom-1">
                    {{ 'reporting.payroll.journalEntry.benefits' | translate }}
                </div>
                <div *ngFor="let benefitReportLineItem of benefitsJournalEntryReportLineItems; last as isLast">
                    <div
                        [class.padding-y-2]="benefitsJournalEntryReportLineItems.length > 1 && !isLast"
                        [class.padding-top-2]="benefitsJournalEntryReportLineItems.length > 1 && isLast"
                        class="app-grid"
                    >
                        <div class="columns-3 non-input-report-line-item">{{ benefitReportLineItem.displayName }}</div>
                        <mat-form-field class="columns-4 no-labels no-helpers">
                            <input
                                (focusout)="onReportItemTemplateChange(benefitReportLineItem)"
                                matInput
                                type="string"
                                placeholder="GL Code"
                                [name]="'glCodeBenefit-' + benefitReportLineItem.id"
                                [(ngModel)]="benefitReportLineItem.glCode"
                            />
                        </mat-form-field>
                        <div class="columns-1"></div>
                        <div class="columns-3 non-input-report-line-item">
                            <mat-checkbox
                                [name]="'separateByDepartmentBenefit' + benefitReportLineItem.id"
                                [(ngModel)]="benefitReportLineItem.separateByDepartment"
                                (change)="onReportItemTemplateChange(benefitReportLineItem)"
                            >
                                <span>{{ 'reporting.payroll.journalEntry.separateByDepartment' | translate }}</span>
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</ui-card>
